/* rb-lsp-messung — zählt, ob Besucher die Widgets der Lampenschirm-Vorlage v5 benutzen (CHG-20260929 pdp-messung).
   Sendet nur Ereignisname + Seiten-Handle an GA4 (G-Z7945445X5) und Clarity — keine Eingaben, keine Personendaten.
   07.10.: dazu die Warenkorb-Schublade (auf/zu, Kasse-Knopf sichtbar, Klickziel, Popup) — siehe schublade().
   Hängt sich nur lesend an (Capture-Listener auf document), greift in keine Kauf- oder Variantenlogik ein;
   jeder Fehler bleibt in diesem Script. Consent: sendet nicht, wenn Shopify customerPrivacy Statistik verbietet;
   gtag/Clarity wenden ihre eigene Einwilligungslogik zusätzlich an. */
(function () {
  if (window.__rbMessung) { return; }
  window.__rbMessung = true;

  var GA4 = 'G-Z7945445X5';
  var seite = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  var einmal = {};

  function erlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') { return cp.analyticsProcessingAllowed() !== false; }
    } catch (e) {}
    return true;
  }

  function sende(name, wert, nurEinmal) {
    try {
      if (nurEinmal) { if (einmal[name]) { return; } einmal[name] = true; }
      if (!erlaubt()) { return; }
      var p = { send_to: GA4, rb_seite: seite };
      if (wert) { p.rb_wert = String(wert).slice(0, 40); }
      if (typeof window.gtag === 'function') { window.gtag('event', name, p); }
      if (typeof window.clarity === 'function') { window.clarity('event', name); }
    } catch (e) {}
  }

  function naechstes(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(sel)) { return el; }
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target, el;
      if ((el = naechstes(t, '[data-rb-schalter]'))) {
        sende('rb_licht_schalter', el.getAttribute('aria-checked') === 'true' ? 'aus' : 'an');
      } else if ((el = naechstes(t, '[data-rb-farbe-knopf]'))) {
        sende('rb_licht_farbe', el.getAttribute('data-rb-farbe-knopf'));
      } else if ((el = naechstes(t, '[data-rb-groesse]'))) {
        sende('rb_groesse_wahl', el.getAttribute('data-rb-groesse'));
      } else if ((el = naechstes(t, '[data-rb-kaufen]'))) {
        sende('rb_kaufband_klick', el.className.indexOf('sticky') > -1 ? 'sticky' : 'band');
      }
    } catch (e) {}
  }, true);

  // toggle blubbert nicht — in der Capture-Phase kommt es trotzdem an
  document.addEventListener('toggle', function (ev) {
    try {
      var d = ev.target;
      if (d && d.tagName === 'DETAILS' && d.open && naechstes(d, '.rb-lsp')) {
        var s = d.querySelector('summary');
        sende('rb_faq_auf', s ? s.textContent.replace(/\s+/g, ' ').trim() : '');
      }
    } catch (e) {}
  }, true);

  function beobachte() {
    try {
      /* 02.10.: Die Kaufleiste (rb-lsp-sticky-huelle) läuft jetzt auf allen PDPs — v5-Ansicht nur bei echten v5-Sektionen. */
      if (!document.querySelector('.rb-lsp:not(.rb-lsp-sticky-huelle)')) { return; }
      sende('rb_v5_ansicht', '', true);
      var licht = document.querySelector('#rb-lsp-licht');
      if (!licht || !('IntersectionObserver' in window)) { return; }
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) { sende('rb_licht_gesehen', '', true); io.disconnect(); }
        });
      }, { threshold: 0, rootMargin: '-35% 0px -35% 0px' }); // zählt, sobald die Sektion die Bildschirmmitte erreicht — auch wenn sie höher als der Bildschirm ist
      io.observe(licht);
    } catch (e) {}
  }


  /* ---------- Warenkorb-Schublade (07.10., CHG tracking-research): wo zwischen Warenkorb und Kasse-Start geht es verloren? ----------
     GA4 kennt add_to_cart und begin_checkout, die Schublade (#cart-drawer, application.js setzt visibility/transform per Inline-Style)
     dazwischen ist blind. Hier nur lesend: auf/zu per MutationObserver am style-Attribut, Kasse-Knopf im Bild per IntersectionObserver,
     Klicks nach Ziel sortiert, Klaviyo-Formular über der offenen Schublade. Keine Mengen, Preise oder Eingaben — nur Ereignisname + Ziel.
     Der Wert steckt im Ereignisnamen (rb_drawer_klick_kasse …), weil GA4 keine Custom Dimension rb_wert kennt (Prüfung 07.10.).
     Zusätzlich Shopify.analytics.publish('roomberry:drawer', …) für einen späteren Custom Pixel (Stufe 2) und Clarity-Tags fürs Segment. */
  function schublade() {
    var d = document.getElementById('cart-drawer');
    if (!d || !('MutationObserver' in window)) { return; }
    var offen = false, kasse = false, seit = 0, io = null, popupTimer = null;
    function tag(k, v) { try { if (typeof window.clarity === 'function') { window.clarity('set', k, v); } } catch (e) {} }
    function pub(ev, p) { try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') { window.Shopify.analytics.publish('roomberry:drawer', Object.assign({ ereignis: ev }, p || {})); } } catch (e) {} }
    function kasseKnopf() { return d.querySelector('.cart-drawer-footer a[href="/checkout"], .cart-drawer-footer a[href*="/checkout"], .cart-drawer-footer button[name="checkout"]'); }
    function popupSichtbar() {
      /* nur schwebende Klaviyo-Formulare (Popup/Flyout mit position:fixed in der Kette), nicht das eingebettete Footer-Formular */
      var fs = document.querySelectorAll('[class*="klaviyo-form"], form[id^="klaviyo"]');
      for (var i = 0; i < fs.length; i++) {
        var f = fs[i], r = f.getBoundingClientRect();
        if (!(r.width > 0 && r.height > 0) || getComputedStyle(f).visibility === 'hidden') { continue; }
        for (var el = f; el && el !== document.body; el = el.parentElement) {
          if (getComputedStyle(el).position === 'fixed') { return true; }
        }
      }
      return false;
    }
    function auf() {
      offen = true; kasse = false; seit = Date.now();
      var leer = !!d.querySelector('.cart-drawer-empty') && !d.querySelector('.cart-drawer-item-quantity');
      sende('rb_drawer_auf_' + (leer ? 'leer' : 'mit_artikel')); tag('rb_drawer', 'auf'); pub('auf', { leer: leer });
      var k = kasseKnopf();
      if (k && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { sende('rb_drawer_kasse_sichtbar'); io.disconnect(); io = null; } });
        }, { threshold: 0.6 });
        io.observe(k);
      } else if (!k && !leer) { sende('rb_drawer_kasse_fehlt'); }
      popupTimer = window.setTimeout(function () { if (offen && popupSichtbar()) { sende('rb_drawer_popup'); tag('rb_popup', 'ueber_drawer'); } }, 1500);
    }
    function zu() {
      offen = false; if (io) { io.disconnect(); io = null; } window.clearTimeout(popupTimer);
      var sek = Math.round((Date.now() - seit) / 1000), stufe = sek < 5 ? 'unter5s' : sek < 20 ? '5_20s' : sek < 60 ? '20_60s' : 'ueber60s';
      sende('rb_drawer_zu_' + (kasse ? 'mit_kasse_' : 'ohne_kasse_') + stufe); tag('rb_kasse', kasse ? 'ja' : 'nein'); pub('zu', { kasse: kasse, sekunden: sek });
    }
    new MutationObserver(function () {
      try {
        var sichtbar = getComputedStyle(d).visibility === 'visible';
        if (sichtbar && !offen) { auf(); } else if (!sichtbar && offen) { zu(); }
      } catch (e) {}
    }).observe(d, { attributes: true, attributeFilter: ['style', 'class'] });
    document.addEventListener('click', function (ev) {
      try {
        if (!offen) { return; }
        var t = ev.target, ziel = null;
        if (naechstes(t, '.cart-drawer-footer a[href*="/checkout"], .cart-drawer-footer button[name="checkout"]')) { ziel = 'kasse'; kasse = true; }
        else if (naechstes(t, '.additional-checkout-buttons')) { ziel = 'express'; kasse = true; }
        else if (naechstes(t, '.cart-drawer-item-quantity-minus, .cart-drawer-item-quantity-plus')) { ziel = 'menge'; }
        else if (naechstes(t, '.cart-drawer-item-remove')) { ziel = 'entfernen'; }
        else if (naechstes(t, '.cart-drawer-footer-discount')) { ziel = 'rabatt'; }
        else if (naechstes(t, '.cart-drawer-header-close-icon')) { ziel = 'schliessen'; }
        else if (naechstes(t, '#cart-drawer-overlay')) { ziel = 'overlay'; }
        else if (naechstes(t, '#cart-drawer .cart-drawer-item a')) { ziel = 'artikel'; }
        else if (naechstes(t, '#cart-drawer')) { ziel = 'sonst'; }
        else if (naechstes(t, '[class*="klaviyo-form"]')) { ziel = 'popup'; }
        if (ziel) { sende('rb_drawer_klick_' + ziel); pub('klick', { ziel: ziel }); }
      } catch (e) {}
    }, true);
    window.addEventListener('pagehide', function () { try { if (offen) { zu(); } } catch (e) {} });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { beobachte(); schublade(); }); } else { beobachte(); schublade(); }
})();
